import { gql } from '@apollo/client';

export const GET_STANDORTE_FOR_MANAGER = gql(`
  query getStandorteForManager {
    manager {
      ... on Manager {
        idStandort
        id
        standorte {
          idStandortgruppe
          uid
          id
          name
          land
          storeNummer
          settings {
            abteilungenEnabled
            isTerminVerknuepfung 
          }
          isAuditAktiv
          featureFlags {
            name
            isActive
          }
        }
      }
      ... on ManagerError {
        type
        message
      }
    }
  }
`);
